import api, {UpdateResp, UUIDApiArg} from "../../api";
import {Enums, Tables, TablesUpdate} from "../../apitypes";
import {supabase} from "../../supabase";

export interface ProfileCreatePayload {
    fullName: string
    roles: Enums<"UserRole">[]
    password: string
    email: string
    worker: Tables<"worker"> | null
}

export type ProfileApiGet = Tables<"profile"> & {
    userRoles: Tables<"userRoles"> | null
    worker: Tables<"worker"> | null
}

export interface UserUpdateArg {
    body: TablesUpdate<"profile">;
    id: string;
    roles?: Enums<"UserRole">[]
}

export interface UUIDUpdateResp {
    status: "ok",
    id?: string
}

export const peopleApi = api.injectEndpoints({
    endpoints: (build) => ({

        createUser: build.mutation<string, ProfileCreatePayload>({
            queryFn: async (args) => {
                const {data, error} = await supabase.rpc("create_user", {email: args.email, password: args.password})
                if (error) return {error};

                const {error: err} = await supabase.from("profile").update({
                    fullName: args.fullName, defaultWorkerID: args.worker?.id || null,
                }).eq("id", data)
                if (err) return {error: err};

                const {error: err2} = await supabase.from("userRoles")
                    .upsert({userID: data, roles: args.roles}, {onConflict: "userID"})
                if (err2) return {error: err2};

                return {data: data}
            },
            invalidatesTags: ["Profile"],
        }),
        // Machine types
        getProfile: build.query<ProfileApiGet[], ProfileFilter>({
            queryFn: async (args) => {
                const q = supabase
                    .from("profile")
                    .select("*, userRoles(*), worker(*)")
                if (args.deleted !== undefined) {
                    if (!args.deleted) {
                        q.is("deleted_at", null)
                    } else {
                        q.not("deleted_at", "is", null)
                    }
                }
                const {data, error} = await q;
                if (error) return {error};
                return {data}
            },
            providesTags: ["Profile"]
        }),
        getProfileById: build.query<ProfileApiGet | null, UUIDApiArg>({
            queryFn: async (args) => {
                const {data, error} = await supabase
                    .from("profile")
                    .select("*,userRoles(*), worker(*)")
                    .eq("id", args.id).single()
                if (error) return {error};
                return {data}
            },
            providesTags: ["Profile"]
        }),
        deleteProfileById: build.mutation<UUIDUpdateResp, UUIDApiArg>({
            queryFn: async (args) => {
                const {error} = await supabase.rpc("delete_user", {uid: args.id})
                if (error) return {error};
                return {data: {status: "ok"}}
            },
            invalidatesTags: ["Profile"],
        }),
        putProfileById: build.mutation<UpdateResp, UserUpdateArg>({
            queryFn: async (args) => {
                const {error} = await supabase.from("profile").update(args.body).eq("id", args.id)
                if (error) return {error};
                if (args.roles) {

                    const {error} = await supabase.from("userRoles")
                        .upsert({userID: args.id, roles: args.roles}, {onConflict: "userID"})
                    if (error) return {error};
                }

                return {data: {status: "ok"}}
            },
            invalidatesTags: ["Profile"],
        }),
    })
});

export interface ProfileFilter {
    deleted?: boolean
}


export const {

    useGetProfileQuery,
    useGetProfileByIdQuery,
    useCreateUserMutation,
    usePutProfileByIdMutation,
    useDeleteProfileByIdMutation,

} = peopleApi;
